module.exports = __webpack_public_path__ + "img/561-270741.png";